import {
  RecommendationsUI,
  Props as RecommendationsUIProps,
} from "./RecommendationsUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function Recommendations({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant } = useVariant(product);
  const placementId = configProps?.placementId
    ? String(configProps.placementId)
    : "";
  const type = configProps?.type as RecommendationsUIProps["type"];
  const maxProductsPerPage = configProps?.maxProductsPerPage
    ? String(configProps.maxProductsPerPage)
    : "5";
  const allowRefresh = configProps?.allowRefresh ? "true" : "false";

  return (
    <RecommendationsUI
      placement={placementId}
      pimProductId={product.aliases.pimProductId}
      skuId={variant.aliases.skuId}
      maxProductsPerPage={maxProductsPerPage}
      allowRefresh={allowRefresh}
      type={type}
    />
  );
}
